// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"7":"63bf8786","8":"cba85c77","16":"6c668601","113":"2b412806","316":"8fbd7ba2","361":"0f27b02c","436":"0e8613ef","455":"ba8dc252","458":"bfd35f6c","804":"5007e035","881":"371085ad","916":"c75bd29c","931":"e94632a4"}[chunkId] + ".js";
};